<script>
import Popper from 'popper.js';
import Toolbar from '@/components/ui/Toolbar';

export default {
  name: 'EditorToolbar',
  components: {
    Toolbar
  },
  props: {
    editor: Object
  },
  data() {
    return {
      active: false,
      popper: null,
      position: 'top'
    };
  },
  watch: {
    editor() {
      if (!this.editor) return;
      if (!this.popper) {
        this.popper = new Popper(this.editor.getRootElement(), this.$refs.toolbar.$el, {
          placement: 'top-start',
          removeOnDestroy: true,
          modifiers: {
            flip: {
              enabled: true
            },
            offset: {
              enabled: true,
              offset: '0px, 16px'
            },
            preventOverflow: {
              enabled: true
            },
            hide: {
              enabled: true
            }
          },
          onUpdate: data => {
            this.position = data.placement === 'bottom-start' ? 'bottom' : 'top';
          }
        });
      }

      // Listen for selection change on the editor
      this.editor.off('change.repeatableToolbar');
      this.editor.on('change.repeatableToolbar', () => this.handleSelectionChange());
      this.handleSelectionChange();
    }
  },
  mounted() {
    document.addEventListener('mousedown', this.cancelMouseDown);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.cancelMouseDown);
  },
  methods: {
    // Prevents toolbar clicks from removing focus from the editor
    cancelMouseDown(event) {
      if (event.target.closest('.toolbar, .el-dropdown-menu')) {
        event.preventDefault();
      }
    },

    // Updates the toolbar when the selection changes (e.g. on NodeChange)
    handleSelectionChange() {
      const editor = this.editor;
      if (!editor) return;

      const el = editor.getSelectedElement();
      const repeatable = el ? el.closest('.cms-repeatable') : null;

      if (repeatable) {
        this.active = true;
        this.popper.reference = repeatable;
        this.popper.scheduleUpdate();
      } else {
        this.active = false;
      }
    }
  }
};
</script>

<template>
  <toolbar
    ref="toolbar"
    :hidden="!editor || !active"
    :position="position"
    :buttons="[
      [
        { icon: 'el-icon-fa-arrow-up', title: $t('Move Up'), click: () => editor.moveRepeatableUp() },
        { icon: 'el-icon-fa-arrow-down', title: $t('Move Down'), click: () => editor.moveRepeatableDown() },
        { icon: 'el-icon-fa-copy', title: $t('Duplicate'), click: () => editor.duplicateRepeatable() },
        { icon: 'el-icon-fa-trash', title: $t('Delete'), click: () => editor.deleteRepeatable() }
      ]
    ]"
    class="repeatable-toolbar"
  />
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.repeatable-toolbar {
  position: absolute;
  z-index: $--index-popper + 3;
}
</style>

